import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const planevaluaiconApi = `${baseUrl}/planes-evaluaciones`;

export const allPlanEvaluacionService = async (params) => {
  const res = await axios.get(planevaluaiconApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const savePlanEvaluacionService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${planevaluaiconApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(planevaluaiconApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const updateEstatusPlanEvaluacionService = async (id, data) => {
  let res = await axios.patch(
    `${planevaluaiconApi}/${id}/update_estatus`,
    data,
    {
      headers: token({}),
    },
  );
  return res;
};

export const onePlanEvaluacionService = async (id) => {
  const res = await axios.get(`${planevaluaiconApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deletePlanEvaluacionService = async (id) => {
  const res = await axios.delete(`${planevaluaiconApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
